import React from 'react';
import { Link } from 'react-router-dom'
import counterpart from 'counterpart';

import './NotFound.scss';
import Panel from '../../components/ui/panel/Panel';
import Text from '../../components/ui/text/Text';
import { connect } from 'react-redux';
import { AppState } from '../..';

interface INotFound {
  isAuth: boolean
}

const NotFound: React.FC<INotFound> = ({ isAuth }) => { 
  const pageWrapper = {
    width: '1360px',
    padding: '20px'
  }

  return (
    <div style={ isAuth ? pageWrapper : {} }>
      <Panel className="error-404" >
        <Text content="NOT_FOUND_CODE" />
        <Text content="NOT_FOUND_TEXT" />
        {!isAuth && <p className="cc-text"><Link id="not-found-login" to="/login">{counterpart("NOT_FOUND_LOGIN")}</Link></p>}
      </Panel>
    </div>
  )
}

export default connect((state: AppState) => ({ isAuth: !!state.auth.parsedToken }), null)(NotFound);